import { MAX_DESCRIPTION_LENGTH } from '../constants';

export const validate = (props) => (values) => {
  const { intl, editMode, maxCompensation } = props;
  const errors = {};

  if (!values.category_id) {
    errors.category_id = intl.formatMessage({
      id: 'complaints.validation.categoryRequired',
      defaultMessage: 'Please select a category',
    });
  }

  if (!values.description || values.description.trim().length < 10) {
    errors.description = intl.formatMessage({
      id: 'complaints.validation.descriptionMin',
      defaultMessage: 'Description must be at least 10 characters',
    });
  }

  if (values.description && values.description.trim().length > MAX_DESCRIPTION_LENGTH) {
    errors.description = intl.formatMessage({
      id: 'complaints.validation.descriptionMax',
      defaultMessage: 'Description must be at most 5000 characters',
    });
  }

  if (!values.desired_compensation || values.desired_compensation <= 0) {
    errors.desired_compensation = intl.formatMessage({
      id: 'complaints.validation.compensationRequired',
      defaultMessage: 'Please enter a compensation amount',
    });
  } else if (maxCompensation && Number(values.desired_compensation) > maxCompensation / 100) {
    errors.desired_compensation = intl.formatMessage(
      {
        id: 'complaints.validation.compensationMax',
        defaultMessage: 'Cannot exceed booking price ({max} kr)',
      },
      { max: maxCompensation / 100 },
    );
  }

  if (!editMode && !values.host_informed) {
    errors.host_informed = intl.formatMessage({
      id: 'complaints.validation.hostInformedRequired',
      defaultMessage: 'You must confirm that the host has been informed',
    });
  }

  return errors;
};
